import React from 'react';
import { Link } from 'react-router-dom';

const BlogPost = props => {
    const { permalink, thumb, postBy, postDate, categories, title, shortDesc } = props.blogData;
    return (
        <article className="blog">
            {thumb && <Link to={"/blog/" + permalink} target="_blank" rel="noreferrer noopener" className="blogImg">
                <img src={thumb} alt={title} />
            </Link>}

            <div className="blogDetails">
                <Link to={"/blog/" + permalink} target="_blank" rel="noreferrer noopener" className="blogTitle"><h2>{title}</h2></Link>

                <div className="blogMeta">By <Link to="/about-me">{postBy}</Link> | On {postDate} | <span className="metaCategory">{categories}</span></div>

                <p className="blog_content">{shortDesc}</p>

                <Link to={"/blog/" + permalink} target="_blank" rel="noreferrer noopener" className="btn-text blogMore">Read More &rarr;</Link>
            </div> {/* Blog Details */}
        </article> // Single Blog
    );
};

export default BlogPost;